<template>
    <button :disabled="moduleConfigurator.steps.length < 3" class="configurator__top-btn btn" @click="CLEAR_ALL">Сбросить</button>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    name: "ResetConfiguration",
    methods : {
        ... mapActions([
            'CLEAR_ALL'
        ]),
    },
    computed : {
        ... mapState([
            'moduleConfigurator'
        ]),
    },
}
</script>

<style scoped>

</style>